// @flow

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import styles from './collectionsHandover.scss';
import { setPageName } from '../../../services/pageService/pageActionCreator';
import {
  getCollectionsHandover,
  filterTableData,
  getCnWiseHandoverDetails,
  initiateHandover,
  uploadHandoverFile,
  downloadCashHandoverTemplate,
  resetHandoverProp,
  initiateWriteOff
} from './collectionsHandoverRedux/collectionsHandoverActionCreator';
import {
  shouldTableDataBeFetchedForNewDateRange,
  getColumnSum,
  checkAuthenticationForSpecificRole
} from '../../../services/helpers';
import SummaryCard from '../../commons/summaryCard/summaryCard';
import SearchBox from '../../commons/searchBox/searchBox';
import ZoomTable from '../../commons/zoomTable/zoomTable';
import Loader from '../../commons/loader/loader';
import AlertsBar from '../../commons/alertsBar/alertsBar';

import CollectionsHandoverPendingModal from '../../commons/collectionsHandoverPendingModal/collectionsHandoverPendingModal';
import ModalWithTable from '../../commons/modalWithTable/modalWithTable';

type Props = {
  collectionsHandoverState: Object,
  setPageName: Function,
  getCollectionsHandover: Function,
  filterTableData: Function,
  getCnWiseHandoverDetails: Function,
  initiateHandover: Function,
  uploadHandoverFile: Function,
  downloadCashHandoverTemplate: Function,
  userProfile: Object,
  resetHandoverProp: Function,
  initiateWriteOff: Function
};

type State = {
  resetSearchText: boolean,
  showCollectionsHandoverPendingModal: boolean,
  showHandoverDetailsModal: boolean,
  viewDetailsData: Array<any>,
  viewDetailsDataBackup: Array<any>,
  viewDetailsModalTitle: string
};

const pageObj = {
  pageName: 'HANDOVER PENDING'
};

class CollectionsHandover extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.openHandoverDetailsModal = this.openHandoverDetailsModal.bind(this);
    this.openCollectionsHandoverPendingModal = this.openCollectionsHandoverPendingModal.bind(
      this
    );
    this.selectedComponentKey = 'RTL_COLLECTIONS_HANDOVER';
    this.collectionsHandoverDateWiseKey = 'RTL_COLLECTIONS_HANDOVER_DATE_WISE';
    this.collectionsHandoverCnWiseKey = 'RTL_COLLECTIONS_HANDOVER_CN_WISE';
    this.alertMessage = 'Nothing to show at the moment';
    this.collectionsHandoverPendingModalTitle = 'Pending Handovers';
    this.selectedUser = {
      id: 1000,
      name: '',
      email: ''
    };
    this.tableActionFunctions = {
      RTL_COLLECTIONS_HANDOVER: Object.assign(
        {},
        {
          showDetails: rowData => {
            // this.props.resetHandoverProp();
            this.selectedUser = {
              id: rowData.userId,
              name: rowData.userName,
              mobile: rowData.userMobile
            };
            this.openHandoverDetailsModal(
              true,
              this.getDatesWithNonZeroPendingHandovers(
                rowData.zoomBookCollectionsHandoverDTOList
              )
            );
          }
        }
      ),
      RTL_COLLECTIONS_HANDOVER_DATE_WISE: Object.assign(
        {},
        {
          getCnWisePendingHandovers: rowData => {
            this.props.resetHandoverProp();
            // close handover details modal
            // get cns data for that date
            this.selectedUser = {
              id: rowData.userId,
              name: rowData.userName,
              mobile: rowData.userMobile
            };
            const cnWiseHandoverDetailsParams = {
              fromDate: moment(rowData.date, 'DD-MM-YYYY')
                .startOf('day')
                .format('x'),
              toDate: moment(rowData.date, 'DD-MM-YYYY')
                .add(1, 'days')
                .startOf('day')
                .format('x'),
              userId: rowData.userId
            };
            this.collectionsHandoverPendingModalTitle = `Date: ${rowData.date}   ${this.selectedUser.name}`;
            this.props.getCnWiseHandoverDetails(cnWiseHandoverDetailsParams);
            this.openHandoverDetailsModal(false);
            this.openCollectionsHandoverPendingModal(true);
          }
        }
      )
    };
    this.state = {
      resetSearchText: false,
      showCollectionsHandoverPendingModal: false,
      showHandoverDetailsModal: false,
      viewDetailsData: [],
      viewDetailsDataBackup: [],
      viewDetailsModalTitle: 'Handover Pending'
    };
    this.handoverDetailsModalTheme = {
      name: 'themeBlack',
      titleCenter: true,
      showBackBtn: false,
      closeIcnWhite: true
    };
  }

  componentWillMount() {
    this.props.setPageName(pageObj);
  }
  componentDidMount() {
    this.props.getCollectionsHandover();
  }

  onSearchValueChange(val) {
    // eslint-disable-next-line
    console.log('on search', val);
    this.props.filterTableData(val);
  }

  getDatesWithNonZeroPendingHandovers(dateWiseTableData) {
    let filtered = [];
    if (dateWiseTableData && dateWiseTableData.length) {
      filtered = dateWiseTableData.filter(obj => obj.pendingCNs > 0);
    }
    return filtered;
  }

  openCollectionsHandoverPendingModal(val, refreshFlag) {
    // eslint-disable-next-line
    console.log(' open close CollectionsHandoverModal ');
    this.setState(
      {
        showCollectionsHandoverPendingModal: val
      },
      () => {
        if (refreshFlag) {
          this.refreshTableData();
        }
      }
    );
  }

  openCollectionsHandoverCnWiseModal(val) {
    // eslint-disable-next-line
    console.log(' Open/Close CollectionsHandoverCnWiseModal ', val);
    this.openCollectionsHandoverModal(true);
  }

  openHandoverDetailsModal(
    openCloseFlag,
    detailsData,
    refreshFlag,
    openWithPreviousStateData
  ) {
    if (openWithPreviousStateData) {
      // this if block is to handle back btn from pending cns to datewise cns
      this.setState({
        showHandoverDetailsModal: openCloseFlag,
        viewDetailsData: this.state.viewDetailsDataBackup || []
      });
    } else {
      this.setState(
        {
          showHandoverDetailsModal: openCloseFlag,
          viewDetailsData: detailsData || [],
          viewDetailsModalTitle: `Handover Pending for ${this.selectedUser.name} `
        },
        () => {
          if (detailsData) {
            this.setState({
              viewDetailsDataBackup: detailsData
            });
          }
          if (refreshFlag) {
            this.refreshTableData();
          }
        }
      );
    }
  }

  renderCashHandoverButton() {
    return (
      <div className={styles.cashHandoverButtonWrapper}>
        <div className={`${styles.filterComponentWrapper}`}>
          <button
            className={`${styles.handoverButton} ${styles.downloadButton}`}
            onClick={() => this.props.downloadCashHandoverTemplate()}
          >
            Download Cash Handover Template
          </button>
        </div>
        <div className={`${styles.filterComponentWrapper}`}>
          <input
            id="handover-file-uploader"
            className={`${styles.fileInput} ${styles.handoverButton}`}
            type="file"
            accept=".csv"
            onChange={e => this.handleHandoverUploaderInput(e)}
          />
          <label
            htmlFor="handover-file-uploader"
            className={styles.handoverButton}
          >
            Upload Cash Handover File
          </label>
        </div>
      </div>
    );
  }

  refreshTableData() {
    this.props.getCollectionsHandover(this.props.collectionsHandoverState);
  }

  handleHandoverUploaderInput(e) {
    e.preventDefault();

    const file = e.target.files[0];

    const formData = new FormData();
    formData.append('file', file);

    this.props.uploadHandoverFile(formData);

    document.getElementById('handover-file-uploader').value = null;
  }

  handoverDetailsModalTheme: Object;
  render() {
    const {
      isLoading,
      tableData,
      tableDataFiltered
    } = this.props.collectionsHandoverState;
    const tableDataLength =
      tableDataFiltered !== null ? tableDataFiltered.length : 0;

    const cashPendingCollection = getColumnSum(
      tableDataFiltered,
      'pendingCashAmount',
      {
        filterColummnKeys: [],
        filterValues: []
      },
      null
    );
    const chequePendingCollection = getColumnSum(
      tableDataFiltered,
      'pendingChequeAmount',
      {
        filterColummnKeys: [],
        filterValues: []
      },
      null
    );
    const onlinePendingCollection = getColumnSum(
      tableDataFiltered,
      'pendingOnlineAmount',
      {
        filterColummnKeys: [],
        filterValues: []
      },
      null
    );
    const writeOffPendingCollection = getColumnSum(
      tableDataFiltered,
      'pendingWriteOffAmount',
      {
        filterColummnKeys: [],
        filterValues: []
      },
      null
    );
    const securityDepositPendingCollection = getColumnSum(
      tableDataFiltered,
      'pendingSecurityDepositAmount',
      {
        filterColummnKeys: [],
        filterValues: []
      },
      null
    );
    const bankTransferPendingCollection = getColumnSum(
      tableDataFiltered,
      'pendingBankTransferAmount',
      {
        filterColummnKeys: [],
        filterValues: []
      },
      null
    );
    return (
      <div className={`${styles.collectionsHandoverWrapper}`}>
        <div className={`${styles.filterPanelParent} l-row a-center`}>
          {checkAuthenticationForSpecificRole(
            'ROLE_UPLOAD_PAY_NEAR',
            this.props.userProfile
          ) && this.renderCashHandoverButton()}
          <div className={`${styles.filterComponentWrapper}`}>
            <SearchBox
              onSearchValueChange={val => this.onSearchValueChange(val)}
              resetSearchText={this.state.resetSearchText}
            />
          </div>
        </div>

        <div className={`${styles.summaryCardParent} l-row`}>
          <SummaryCard
            totalAmount={
              cashPendingCollection +
              chequePendingCollection +
              onlinePendingCollection +
              writeOffPendingCollection +
              bankTransferPendingCollection +
              securityDepositPendingCollection
            }
            totalAmountTag="Pending"
            subAmountLeftTag="Cash"
            subAmountLeft={cashPendingCollection}
            subAmountRightTag="Cheque"
            subAmountRight={chequePendingCollection}
            subAmountCenterTag="Online"
            subAmountCenter={onlinePendingCollection}
            subAmountBottomLeftTag="Write Off"
            subAmountBottomLeft={writeOffPendingCollection}
            subAmountBottomRightTag="Security Deposit"
            subAmountBottomRight={securityDepositPendingCollection}
            subAmountBottomCenterTag="Bank Transfer"
            subAmountBottomCenter={bankTransferPendingCollection}
            showPercentage={false}
            type="HANDOVER"
          />
        </div>

        <div className={`${styles.modalParent}`}>
          <CollectionsHandoverPendingModal
            showModal={this.state.showCollectionsHandoverPendingModal}
            closeModal={(val, refreshFlag) =>
              this.openCollectionsHandoverPendingModal(val, refreshFlag)
            }
            cnWiseData={this.props.collectionsHandoverState.cnWiseHandoverData}
            tableKey={this.collectionsHandoverCnWiseKey}
            title={this.collectionsHandoverPendingModalTitle}
            initiateHandoverMethod={this.props.initiateHandover}
            handoverObject={this.props.collectionsHandoverState.handover}
            writeOffObject={this.props.collectionsHandoverState.writeOff}
            resetHandoverProp={this.props.resetHandoverProp}
            selectedUser={this.selectedUser}
            userProfile={this.props.userProfile}
            showHandoverDetailsModal={() => {
              this.openHandoverDetailsModal(true, null, null, true);
              this.openCollectionsHandoverPendingModal(false);
            }}
            initiateWriteOffMethod={this.props.initiateWriteOff}
          />
          <ModalWithTable
            title={this.state.viewDetailsModalTitle}
            showModal={this.state.showHandoverDetailsModal}
            closeModal={(val, refreshFlag) =>
              this.openHandoverDetailsModal(val, null, refreshFlag)
            }
            modalTheme={this.handoverDetailsModalTheme}
            tableKey={this.collectionsHandoverDateWiseKey}
            tableData={this.state.viewDetailsData}
            tableActionFunctions={
              this.tableActionFunctions[this.collectionsHandoverDateWiseKey]
            }
          />
        </div>

        <div className={`${styles.tableWrapper}`}>
          {isLoading ? <Loader /> : ''}
          {!isLoading && tableData && tableData.length ? (
            <ZoomTable
              configKey={this.selectedComponentKey}
              tableDataLength={tableDataLength}
              tableData={tableDataFiltered}
              actionFunctions={
                this.tableActionFunctions[this.selectedComponentKey]
              }
            />
          ) : (
            <AlertsBar message={this.alertMessage} loading={isLoading} />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  collectionsHandoverState: state.collectionsHandoverState,
  userProfile: state.userProfile
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  getCollectionsHandover: bindActionCreators(getCollectionsHandover, dispatch),
  filterTableData: bindActionCreators(filterTableData, dispatch),
  getCnWiseHandoverDetails: bindActionCreators(
    getCnWiseHandoverDetails,
    dispatch
  ),
  initiateHandover: bindActionCreators(initiateHandover, dispatch),
  uploadHandoverFile: bindActionCreators(uploadHandoverFile, dispatch),
  downloadCashHandoverTemplate: bindActionCreators(
    downloadCashHandoverTemplate,
    dispatch
  ),
  resetHandoverProp: bindActionCreators(resetHandoverProp, dispatch),
  initiateWriteOff: bindActionCreators(initiateWriteOff, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectionsHandover);
